import { glacierPolicyApiAssignableOptions } from '@/lib/heyapi/@tanstack/react-query.gen';

import { useQuery } from '@tanstack/react-query';
import { TransferView } from './TransferView';

export const Transfer = ({ accountId }: { accountId: string }) => {
  const { data } = useQuery({
    ...glacierPolicyApiAssignableOptions({
      path: {
        account_id: accountId,
      },
    }),
  });
  return <TransferView accountId={accountId} related={data || []} />;
};
